import appPage from '../../../hoc/appPage';
import ErrorView from '../../../views/ErrorView';

export default appPage(ErrorView, false);
